module.exports = __webpack_public_path__ + "img/cross_icon.5601d712.svg";